module.exports = __webpack_public_path__ + "img/icon-status-08.106b35f2.svg";